<div class="flex flex-col w-full pb-4">
  <div class="flex flex-col pl-[2px] mb-1">
    <div class="text-sm text-slate-900">
      <span>{{ title }} </span>
    </div>

    @if (subTitle) {
      <div class="text-xs text-slate-400 italic">
        <span>{{ subTitle }}</span>
      </div>
    }
  </div>

  <dx-progress-bar
    [min]="0"
    [max]="allSteps"
    [value]="counter()"
    height="10"
    [statusFormat]="format"
    (onComplete)="onComplete()"
  >
  </dx-progress-bar>
</div>
